export default __webpack_public_path__ + "static/media/profile_picture.13090688.jpg";